import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useState } from 'react';
export var SORT_ASC = 'ASC';
export var SORT_DESC = 'DESC';
export function getIconDirection(direction) {
  return direction === SORT_ASC ? 'arrow-up' : 'arrow-down';
}
export function getOppositeSortDirection(direction) {
  return direction === SORT_ASC ? SORT_DESC : SORT_ASC;
}

function parseSortOrder(query) {
  var isDescending = query[0] === '-';
  return {
    columnId: isDescending ? query.substring(1) : query,
    direction: isDescending ? SORT_DESC : SORT_ASC
  };
}

function getSortOrder(_ref) {
  var columnId = _ref.columnId,
      direction = _ref.direction;
  return "" + (direction === SORT_ASC ? '' : '-') + columnId;
}

function getDefaultSort(_ref2) {
  var columnId = _ref2.columnId,
      direction = _ref2.direction,
      order = _ref2.order;
  var defaultSort = order ? parseSortOrder(order) : {
    columnId: columnId,
    direction: direction
  };
  return _objectSpread(_objectSpread({}, defaultSort), {}, {
    order: getSortOrder(defaultSort)
  });
}

export default function useColumnSort(_ref3) {
  var _ref3$defaultSort = _ref3.defaultSort,
      defaultSort = _ref3$defaultSort === void 0 ? {
    columnId: null,
    direction: SORT_ASC,
    order: null
  } : _ref3$defaultSort,
      onColumnSort = _ref3.onColumnSort;

  var _useState = useState(getDefaultSort(defaultSort)),
      currentSort = _useState[0],
      setCurrentSort = _useState[1];

  var sortColumnById = useCallback(function (column) {
    setCurrentSort(function (currentSort) {
      var parsedDefaultSort = getDefaultSort(_objectSpread(_objectSpread({}, defaultSort), {}, {
        direction: column.defaultSortDirection
      }));
      var nextSort = {
        columnId: column.id
      };

      if (currentSort.columnId === column.id) {
        nextSort.direction = getOppositeSortDirection(currentSort.direction);
      } else {
        nextSort.direction = column.defaultSortDirection || SORT_ASC;
      }

      nextSort.order = getSortOrder(nextSort);

      if (onColumnSort) {
        onColumnSort(nextSort.columnId ? nextSort : parsedDefaultSort);
      }

      return nextSort;
    });
  }, [defaultSort, onColumnSort]);
  return {
    currentSort: currentSort,
    sortColumnById: sortColumnById
  };
}